
<section class="password-section container-fluid sts-section sts-form">

  <app-sts-section-header key="sts-password-header" [errors]="errors" [texts]="errorTexts">Set up password</app-sts-section-header>

  <div class="load-indicator-container" *ngIf="!pageLoaded">
    <div class="load-indicator">
      <label class="load-label">Verifying...</label>
      <img app-sts-cms-image bypass="true" default="/tools/ariel-sts-app/{#clientCode#}/app/assets/clients/{#clientCode#}/images/loader-inside.gif"/>
    </div>
  </div>

  <div>
    <app-sts-section-body key="sts-password-blacklist-title" *ngIf="blacklistTexts && blacklistTexts.length">
      <div class="col-24 password-instruction-top">Your password must not include:</div>
    </app-sts-section-body>


    <div class="col-24 password-instruction-middle">
      <ul>
        <li *ngFor="let o of blacklistTexts; let i = index">{{o}}</li>
      </ul>
    </div>

    <app-sts-section-body key="sts-password-policy-title" *ngIf="Rules && Rules.length">
      <div class="col-24 password-instruction-top">Your password must include:</div>
    </app-sts-section-body>

    <div class="col-24 password-instruction-middle">
      <ul>
        <li *ngFor="let o of Rules; let i = index">{{o}}</li>
      </ul>
    </div>
    <div app-sts-cms-txt key="sts-confirm-new-password" >Once you have confirmed your password, select <span class="bold">Save</span> to continue.</div>

    <form (ngSubmit)="onSubmit()" autocomplete="off" class="sts-form">
      <div class="row">
        <div class="col-24">
          <div class="sts-object">
            <div *ngIf="setNewPasswordFlow==false">
              <div class="sts-label-row">
                <label for="existingPassword" app-sts-cms-txt key="sts-existing-password">
                  Existing password:
                </label>
              </div>
              <div class="sts-input-row">
                <input type="password" class="sts-textbox" id="existingPassword" name="existingPassword"
                       [(ngModel)]="stsChangePassword.existingPassword" #existingPassword="ngModel"
                       [disabled]="formSubmitSuccess"
                       >
                <app-sts-show-error key="sts-field-error-existingpassword-required" description="Existing password is a required field" [show]="!existingPasswordValid"></app-sts-show-error>
              </div>
            </div>

            <div class="sts-label-row">
              <label for="newPassword" app-sts-cms-txt key="sts-new-password">New password:</label>
            </div>
            <div class="sts-input-row">
              <input type="password"
                     class="sts-textbox"
                     id="newPassword"
                     name="newPassword"
                     [ngClass]="{'has-errors': !newPasswordValid}"
                     [(ngModel)]="stsChangePassword.newPassword"
                     #newPassword="ngModel"
                     [disabled]="formSubmitSuccess" >
              <app-sts-show-error key="sts-field-error-newpassword-required" description="New password is a required field" [show]="!newPasswordValid"></app-sts-show-error>
            </div>

            <div class="sts-label-row">
              <label for="confirmPassword" app-sts-cms-txt key="sts-confirm-password">Confirm password:</label>
            </div>
            <div class="sts-input-row">
              <input type="password"
                     class="sts-textbox"
                     id="confirmPassword"
                     name="confirmPassword"
                     [ngClass]="{'has-errors': !confirmPasswordValid}"
                     [(ngModel)]="stsChangePassword.confirmPassword"
                     #confirmPassword="ngModel"
                     [disabled]="formSubmitSuccess" >
              <app-sts-show-error key="sts-field-error-confirmpassword-required" description="Confirm password is a required field" [show]="!confirmPasswordValid"></app-sts-show-error>
            </div>
          </div>


          <div class="sts-object">

            <button *ngIf="!formSubmitSuccess" class="sts-btn other-sts-btn" type="button" (click)="cancel()" app-sts-cms-txt key="sts-cancel-button">Cancel</button>

            <app-sts-button key="sts-save" *ngIf="!formSubmitSuccess">Save</app-sts-button>

            <!--
            To use this in case we want the Save button to not enable
            till the form is valid.
            [ngClass]="{'disabled': !validateFields(false) || formSubmitSuccess}"
            [disabled]="!validateFields(false) || formSubmitSuccess" -->

            <button *ngIf="!setNewPasswordFlow && formSubmitSuccess" class="sts-btn" type="button" (click)="onContinue()" app-sts-cms-txt key="sts-continue">Continue</button>

            <button *ngIf="setNewPasswordFlow && (answersProvided || !securityQuestionsActive) && formSubmitSuccess" class="sts-btn" type="button" (click)="onContinue()" app-sts-cms-txt key="sts-back-to-signin">Back to sign in</button>


          </div>
        </div>
      </div>

    </form>
  </div>

</section>
